import UseTranslationHook from "../../hooks/UseTranslationHook";
import { dateFormat, getLocalDate } from "../../utils/AppFunctions";

export interface IFormFooterProps {
  created_by?: string;
  created_date?: string;
  modified_by?: string;
  modified_date?: string;
}

export const FormFooter = (props: IFormFooterProps) => {
  const { t } = UseTranslationHook();
  const { created_by, created_date, modified_by, modified_date } = props;
  return (
    <div className="px-2 pt-2 border-t w-full">
      <div className="flex">
        {created_date && (
          <>
            <h6 className="font-medium">{t("created_on")}&nbsp;:&nbsp;</h6>
            <p>{dateFormat(getLocalDate(created_date))}</p>
          </>
        )}

        {created_by && (
          <>
            &nbsp; {t("by")}
            <p>&nbsp;{created_by}</p>
          </>
        )}
      </div>
      {modified_date && (
        <div className="flex">
          <h6 className="font-medium">{t("modified_on")}&nbsp;:&nbsp;</h6>
          <p>{dateFormat(getLocalDate(modified_date))}</p>
          {modified_by && (
            <>
              &nbsp; {t("by")}
              <p>&nbsp;{modified_by}</p>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default FormFooter;
